import { pluralize } from '@/filters';
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time) * 1000;
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }

    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }

    return value || 0;
  });

  return timeStr;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return 'Just now';
  } else if (diff < 3600) {
    // less 1 hour
    return pluralize(Math.ceil(diff / 60), ' minute') + ' ago';
  } else if (diff < 3600 * 24) {
    return pluralize(Math.ceil(diff / 3600), ' hour') + ' ago';
  } else if (diff < 3600 * 24 * 2) {
    return '1 day ago';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      pluralize(d.getMonth() + 1, ' month') + ' ' +
      pluralize(d.getDate(), ' day') + ' ' +
      pluralize(d.getHours(), ' day') + ' ' +
      pluralize(d.getMinutes(), ' minute')
    );
  }
}

/**
 * Get query object from URL
 * @param {string} url
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });

  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) {
      s++;
    } else if (code > 0x7ff && code <= 0xffff) {
      s += 2;
    }
    if (code >= 0xDC00 && code <= 0xDFFF) {
      i--;
    }
  }
  return s;
}

/**
 * Remove invalid (not equal true) elements from array
 *
 * @param {Array} actual
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }

  return newArray;
}

/**
 * Parse params from URL and return an object
 *
 * @param {string} url
 */
export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  );
}

/**
 * @param {string} val
 */
export function html2Text(val) {
  const div = document.createElement('div');
  div.innerHTML = val;

  return div.textContent || div.innerText;
}

/**
 * Merges two  objects, giving the last one precedence
 *
 * @param {Object} target
 * @param {Object} source
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });

  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }

  element.className = classString;
}

export const pickerOptions = [
  {
    text: 'Now',
    onClick(picker) {
      const end = new Date();
      const start = new Date(new Date().toDateString());
      end.setTime(start.getTime());
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: 'Last week',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: 'Last month',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: 'Last three months',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    },
  },
];

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * Base64转成文件
 * @param  data_url  图片base64
 * @param  file_name 文件名称
 */
export function base64ImgtoFile(data_url, file_name) {
  const arr = data_url.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const suffix = mime.split('/')[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${file_name}.${suffix}`, {
    type: mime,
  });
}

/**
 * 文件转base64
 * @param  file  文件对象
 */
export function imageToBase64(file) {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    return reader.result;
  };
  reader.onerror = function(error) {
    console.log('Error: ', error);
  };
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // According to the last trigger interval
    const last = new Date().getTime() - timestamp;

    // The last time the wrapped function was called, the interval is last less than the set time interval wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = args = null;
        }
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = new Date().getTime();
    const callNow = immediate && !timeout;
    // If the delay does not exist, reset the delay
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });

  return targetObj;
}

/**
 * @param {Object[]} arr
 * @returns {Object[]}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * 去重
 * @param {Array<object>} arr 数组
 * @param {string} key 键值
 * @returns {Array<object>}
 */
export function unique(arr, key) {
  const res = new Map();
  return arr.filter((arr) => !res.has(arr[key]) && res.set(arr[key], 1));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + '';
  const randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 *
 * @param {HTMLElement} elm
 * @param {String} cls
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 *
 * @param {HTMLElement} elm
 * @param {String} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) {
    ele.className += ' ' + cls;
  }
}

/**
   * 解构json
   * @param {Object} jsonObj
   * @param {String} key
   * @returns
   */
export function parseJson(jsonObj, key) {
  // 循环所有键
  for (const v in jsonObj) {
    const element = jsonObj[v];
    // 判断是否为对象
    if (toString.call(element) === `[object Object]`) {
      const result = parseJson(element, key);
      if (result) {
        return result;
      }
    } else {
      if (v === key) {
        return jsonObj[key];
      }
    }
  }
}

/**
 * Remove class from element
 *
 * @param {HTMLElement} elm
 * @param {String} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/** 根据目标对象格式合并两个的对象
 * @param target_obj  目标对象
 * @param source_obj  来源对象
 */
export function mergeObject(target_obj, source_obj) {
  if (toString.call(source_obj) !== `[object Object]`){
    return;
  }
  for (const key in source_obj){
    if (toString.call(target_obj[key]) === `[object Object]`){
      mergeObject(target_obj[key], source_obj[key]);
    } else {
      target_obj[key] || target_obj[key] === 0 ? target_obj[key] = source_obj[key] : '';
    }
  }
  return target_obj;
}

/**
 * 获取链接上的参数
 *
 * @param {*} myurl 链接
 * @param {*} paramName 参数名
 * @returns
 */
export function getUrlParam(myurl, paramName){
  var url = myurl;
  var arrObj = url.split('?');
  var arr = [];
  var obj = {};

  if (!arrObj[1]) {
    return;
  }

  var arrPara = arrObj[1].split('&');

  if (arrObj.length > 1) {
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=');
      obj[arr[0]] = decodeURIComponent(arr[1]);
      if (arr != null && arr[0] === paramName) {
        return decodeURIComponent(arr[1]);
      }
    }
    return obj;
  } else {
    arrPara = myurl.split('&');
    if (arrPara.length > 0){
      for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=');
        obj[arr[0]] = decodeURIComponent(arr[1]);
        if (arr != null && arr[0] === paramName) {
          return decodeURIComponent(arr[1]);
        }
      }
      return obj;
    } else {
      arr = myurl.split('=');
      obj[arr[0]] = decodeURIComponent(arr[1]);
      if (arr != null && arr[0] === paramName) {
        return decodeURIComponent(arr[1]);
      }
    }

    return obj;
  }
}

export function clone(obj) {
  var o;
  // 如果  他是对象object的话  , 因为null,object,array  也是'object';
  if (typeof obj === 'object') {
    // 如果  他是空的话
    if (obj === null) {
      o = null;
    } else {
      // 如果他是数组arr的话
      if (obj instanceof Array) {
        o = [];
        for (var i = 0, len = obj.length; i < len; i++) {
          o.push(clone(obj[i]));
        }
      } else {
        // 如果他是对象object的话
        o = {};
        for (var j in obj) {
          o[j] = clone(obj[j]);
        }
      }
    }
  } else {
    o = obj;
  }
  return o;
}

/**
 * 队列执行方法
 * @param {Array<any>} list 请求数据源数组
 * @param {number} limit 是每次并行发起多少个请求
 * @param {Promise | Promise[]} handleFn 就是异步处理函数
*/
export function limitQueueFn(list, limit, handleFn) {
  const attr_obj = {
    // 成功回调
    _succeCallBack: null,
    // 错误回调
    _errorCallBack: null,
    // 成功
    success: function(callBack) {
      this._succeCallBack = callBack;
      return attr_obj;
    },
    // 错误
    error: function(callBack) {
      this._errorCallBack = callBack;
      return attr_obj;
    },
  };

  // 任务控制
  const task_control = {
    // 任务索引值
    index: 0,
    // 完成任务数
    complete_num: 0,
    // 执行一个任务
    run: function() {
      // 构造待执行任务 当该任务完成后 如果还有待完成的任务 继续执行任务
      new Promise((resolve) => {
        const value = list[this.index];
        // resolve 返回 promise
        if (handleFn instanceof Array) {
          if (handleFn[this.index]) {
            resolve(handleFn[this.index](value));
          }
        } else {
          resolve(handleFn(value));
        }
        this.index++;
      }).then(() => {
        this.complete_num++;

        if (this.complete_num < list.length) {
          this.run();
        } else if (this.complete_num === list.length){
          // 成功回调
          if (attr_obj._succeCallBack) {
            attr_obj._succeCallBack();
          }
        }
      }).catch((err) => {
        // 错误回调
        if (attr_obj._errorCallBack) {
          attr_obj._errorCallBack(err);
        }
      });
    },
  };

  // 第一次的时候 一次性执行 limit 个任务
  for (let i = 0; i < limit; i++) {
    task_control.run();
  }

  return attr_obj;
}

/**
 * 生成唯一字符串
 * @param {number} len 指定生成字串的长度
 * @param {number} radix 指定生成字串的基数长度
 * @returns {string}
 */
export function randomUUID(len = 32, radix = 16) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | (Math.random() * radix)];
    }
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

/**
 * 字符串模板替换
 * @param template 字符串模板
 * @param context 字符串替换对象
 * @returns { string }
 * @example
 * renderTemplate(`一年有{{season}}季，共{{day}}天`, { season: '四', day: 365 })
 * 返回值：'一年有四季，共365天'
 */
export function renderTemplate(template, context) {
  return template.replace(/\{\{(.*?)\}\}/g, (match, key) => context[key.trim()]);
}

/**
 * 字符串路径对象转换为嵌套的普通关联对象
 * @param {Object} path_object 字符串路径对象
 * @returns {Object} 嵌套的普通关联对象
 * @example convertPathObject({'1.name':'alex','1.age': 18}) => {1:{name:'alex',age:18}}
 */
export function convertPathObject(path_object) {
  const result = {};
  for (const path in path_object) {
    const segments = path.split('.');
    let target = result;
    segments.forEach((segment, i, arr) => {
      if (!target[segment]) {
        if (i === arr.length - 1) {
          target[segment] = path_object[path];
        } else {
          target[segment] = arr[i + 1]?.match(/^\d+$/) ? [] : {};
        }
      }
      if (i === segments.length - 2 && Array.isArray(target[segment])) {
        const index = parseInt(arr[i + 1]);
        target[segment][index] = path_object[path];
      }
      target = target[segment];
    });
  }
  return result;
}

/**
 * 数组分块
 * @param {any[]} arr 数组
 * @param {number} size 每块的长度
 */
export function chunk(arr, size) {
  const chunked = [];
  let index = 0;
  while (index < arr.length) {
    chunked.push(arr.slice(index, index + size));
    index += size;
  }
  return chunked;
}

/**
 * 根据 object对象的path路径获取值。 如果解析 value 是 undefined 会以 defaultValue 取代
 * @param {Object} object 要检索的对象。
 * @param {string} path 要获取属性的路径。
 * @param {*} [defaultValue] 如果解析值是 undefined ，这值会被返回
 */
export function getValueByPath(object, path, default_value) {
  try {
    if (typeof object !== 'object' || typeof path !== 'string') {
      return default_value;
    }
    const paths = path.split('.');
    let target = object;
    paths.forEach(p => (target = target[p]));
    return target || default_value;
  } catch {
    return default_value;
  }
}

/**
 * 节流
 * @param func 待执行函数
 * @param delay 时间
 * @returns {Function}
 */
export function throttle(func, delay) {
  let timeoutId;
  let lastExecTime = 0;
  return function(...args){
    const currentTime = Date.now();
    const elapsedTime = currentTime - lastExecTime;
    if (elapsedTime >= delay) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      lastExecTime = currentTime;
      func(...args);
    } else {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        lastExecTime = currentTime;
        func(...args);
      }, delay - elapsedTime);
    }
  };
}

/**
 * 获取两个数组的交集
 * @param {any[]} arr1 数组1
 * @param {any[]} arr2 数组2
 * @returns {any[]} 两个数组的交集
 */
export function getArrayIntersection(arr1, arr2) {
  const res = new Set(arr2);
  return [...arr1].filter((x) => res.has(x));
}

/**
 * 简易版防抖
 * @param {Function} fn 待执行函数
 * @param {number} wait 等待毫秒数
 * @returns {Function}
 */
export function debounceSimple(fn, wait) {
  let timer = null;
  return function handler(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
}

/**
 * 扁平化对象数组
 * @param {any[]} arr 目标数组
 * @param {string} key 扁平化的目标属性，默认为children
 * @returns {any[]} 扁平化后的数组
 * @example
 * flattenObjArray([{ a: 1, child: [{ a: 2 }] }, { a: 3, child: [{ a: 4 }] }], 'child')
 * return: [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }]
 */
export function flattenObjArray(arr, key = 'children') {
  let result = [];

  arr.forEach(item => {
    result.push(item);
    if (item[key]) {
      result = result.concat(flattenObjArray(item[key], key));
      delete item[key];
    }
  });

  return result;
}

/**
 * 选项结构转化为表结构
 * @param {object[]} options 选项
 * @param {string} label 标签的key
 * @param {string} value 值的key
 */
export function transformSchema(options = [], label = 'label', value = 'value'){
  if (!options?.length) {
    return {};
  }
  const result = {};
  options.forEach(o => (result[o[value]] = o[label]));
  return result;
}

/**
 * 对象深度合并
 * @param {Object[]} sources 对象组成的数组
 * @returns {Object}
 * @example
 * deepMerge([{ name: 1 }, { age: 2 } ]);
 * 输出：{ "name": 1, "age": 2 }
 *
 * deepMerge([{ name: 1, age: 1 }, { age: 2 } ]);
 * 输出：{ "name": 1, "age": 2 }
 *
 * deepMerge([{ name: 1, interest: ["football", "music"] }, { age: 2, interest: ["football"] } ]);
 * 输出：{ "name": 1, "interest": ["football", "music"], "age": 2 }
 *
 */
export function deepMerge(sources) {
  function isArray(val) {
    return Object.prototype.toString.call(val) === '[object Array]';
  }

  if (!isArray(sources) || sources.length === 0) {
    return {};
  }

  const visited = new WeakMap();

  function isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  }

  function mergeArrays(targetArray, sourceArray) {
    return [...new Set([...targetArray, ...sourceArray])];
  }

  function merge(target, source) {
    if (!isObject(target) || !isObject(source)) {
      return source;
    }

    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        const source_value = source[key];
        let target_value = target[key];

        if (isObject(source_value) && !visited.has(source_value)) {
          visited.set(source_value, true);

          // 如果target中没有该key或对应的值不是对象，则初始化一个新对象进行合并
          if (!target.hasOwnProperty(key) || !isObject(target_value)) {
            target_value = {};
          }
          // 递归合并对象
          target[key] = merge(target_value, source_value);
        } else if (Array.isArray(source_value) && Array.isArray(target_value)) {
          // 合并数组
          target[key] = mergeArrays(target_value, source_value);
        } else {
          // 直接赋值
          target[key] = source_value;
        }
      }
    }

    return target;
  }

  return sources.reduce((acc, curr) => merge(acc, curr), {});
}

/**
 * 求两个数组的差集
 * @param {Array<string | number>} arr1 数组1
 * @param {Array<string | number>} arr2 数组2
 * @returns {Array<string | number>}
 */
export function getArrayDifference(arr1, arr2) {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  const result = [];
  for (const num of set1) {
    if (!set2.has(num)) {
      result.push(num);
    }
  }
  for (const num of set2) {
    if (!set1.has(num)) {
      result.push(num);
    }
  }
  return result;
}

/**
 * 校验对象是否存在某个属性
 * @param {Object} target 目标对象
 * @param {string} key 属性键
 * @returns {boolean}
 */
export function hasOwnProperty(target, key) {
  return Object.prototype.hasOwnProperty.call(target || {}, key);
}

/**
 * 随机打乱数组
 * @param {any[]} arr 数组
 * @returns {any[]}
 */
export function shuffleArray(arr) {
  // 创建数组的副本，避免修改原数组
  const shuffled = [...arr];

  // 从后向前遍历数组
  for (let i = shuffled.length - 1; i > 0; i--) {
    // 随机生成一个 [0, i] 范围内的索引
    const j = Math.floor(Math.random() * (i + 1));

    // 交换当前元素和随机位置的元素
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
}
